import Vue from "vue";
import Vuetify from "vuetify/lib";
import pt from 'vuetify/es5/locale/pt';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#7051F0",
        secondary: "#6F8ED8",
        accent: "#6EECB4",
        error: "#FF5252",
        info: "#6FAFCB",
        success: "#4CAF50",
        warning: "#FFC107",
        lightred: "#FFCDD2",
        whitegrey: "#F2F2F2",

        status_active: "#D4F0FF",
        status_active_dot: "#6F8ED8",
        status_doing: "#D4F0FF",
        status_doing_dot: "#6F8ED8",
        status_overdue: "#FFF3D4",
        status_overdue_dot: "#D8B46F",
        status_done: "#D4FFD6",
        status_done_dot: "#77D86F",
        status_canceled: "#FFD4D4",
        status_canceled_dot: "#D86F6F",
        status_not_started: "#E0E0E0",
        status_not_started_dot: "#A5A5A5",
        alteration: "#E7D4FF",
        alteration_dot: "#9D6FD8",
        status_waiting: "#E7D4FF",
        status_waiting_dot: "#9D6FD8",

        status_active: "#D4F0FF",
        status_active_dot: "#6F8ED8",
        status_stale: "#FFF3D4",
        status_stale_dot: "#D8B46F",
        status_inactive: "#E7D4FF",
        status_inactive_dot: "#9D6FD8",
      }
    },
    options: {
      customProperties: true
    }
  },
  lang: {
    locales: { pt },
    current: 'pt',
  },
  icons: {
    iconfont: "mdi",
    // default icons. Chamar em $vuetify.icons.[icon-value]
    values: {
      user: "mdi-account",
      list: "mdi-format-list-bulleted",
      logout: "mdi-logout",
      home: "mdi-home"
    }
  }
});
